import { tv } from 'tailwind-variants';

const carouselAutoplayToggleStyles = tv({
    base: `
    iris:absolute 
    iris:right-0
    iris:bottom-4 
    iris:z-20
    iris:mr-(--comp-space-padding-carousel-controls-all)
  `,
});

export { carouselAutoplayToggleStyles as default };
